var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [分享]
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis/index';
import AppEnv from '../../env';
import { AjaxBasics, BaseModel } from '../../libraries';
import { onCreateFactoryUser } from './userModel';
let ShareController = class ShareController {
    constructor() {
        /**
         * 用户信息
         * @memberof SystemController
         */
        this.User = onCreateFactoryUser();
        /**
         * 分享信息
         * @memberof ShareController
         */
        this.Model = new BaseModel({ storageKey: 'share' });
        /**
         * 生成推广码
         * @param shareUrl
         * @param shareModule
         * @returns
         */
        // getShareCode(shareUrl, shareModule) {
        //     return AjaxBasics.request<string>({ ...EnumAPI.content_share_code, body: { shareUrl, shareModule } })
        // }
    }
    /**
     * 分享码 用户
     * @readonly
     * @memberof ShareController
     */
    get shareCode() {
        return lodash.get(this.Model.value, 'shareCode', '');
    }
    /**
     * 分享时间戳
     * @readonly
     * @memberof ShareController
     */
    get shareTime() {
        return lodash.get(this.Model.value, 'shareTime', '');
    }
    /**
     * 分享类型
     * @readonly 1 小程序&卡片，2 太阳码  3 二维码
     * @memberof ShareController
     */
    get shareType() {
        return lodash.get(this.Model.value, 'shareType', '1');
    }
    /**
     * 场景码
     * @readonly
     * @memberof ShareController
     */
    get scene() {
        return lodash.get(this.Model.value, 'scene', '');
    }
    get businessType() {
        // shera BU
        // this.User.BU
        // SMB
        return lodash.defaultTo(lodash.get(this.Model.value, 'businessType'), this.User.BU);
    }
    get identityId() {
        return lodash.get(this.Model.value, 'identityId');
    }
    get userId() {
        return lodash.get(this.Model.value, 'userId');
    }
    /**
     * 获取请求头 参数值
     * @returns
     */
    getHeaderValue() {
        const code = lodash
            .map(lodash.pickBy(lodash.pick(this, lodash.keys(this.onCreateQuery())), lodash.identity), (value, key) => `${key}=${value}`)
            .join(';');
        return code;
    }
    /**
     * 创建分享参数
     */
    onCreateQuery(query = {}) {
        return lodash.assign({
            // 分享时间戳
            shareTime: Date.now(),
            // 用户分享码 或者 之前的分享码
            shareCode: this.User.shareCode || this.shareCode,
            // 身份id
            identityId: this.User.identityId || this.identityId,
            // 当前用户BU
            businessType: this.User.BU || this.businessType,
            // user id
            userId: this.User.userId || this.userId,
            // 类型
            shareType: this.shareType,
            // 场景值
            scene: this.scene,
        }, query);
    }
    /**
     * 解析分享参数
     * @memberof shareCode,shareTime,shareType
     */
    onParseShare(query = {}) {
        query = this.onCompliantScene(query);
        this.Model.merge(lodash.pickBy(lodash.pick(query, lodash.keys(this.onCreateQuery())), lodash.identity));
        return this;
    }
    /**
     * 兼容小程序 scene
     * @param query
     * @returns
     */
    onCompliantScene(query) {
        // 扫码进入
        if (lodash.has(query, 'scene') && !lodash.has(query, 'shareCode')) {
            lodash.set(query, 'shareCode', lodash.get(query, 'scene'));
            lodash.set(query, 'shareType', '2');
        }
        else if (lodash.hasIn(query, 'share')) {
            const [token, shareCode, scene] = lodash.split(lodash.get(query, 'share'), AppEnv.shareSeparate);
            this.Model.merge({ shareCode, scene });
        }
        return query;
    }
    /**
     * 推广记录
     * @returns
     * shareCode ;         // 分享码  请求头         调用token接口返回字段中包含 shareCode
     * pageUrl;            //打开连接
     * shareTime;          //分享时间戳     格式：yyyy-MM-dd HH:mm:ss
     * shareType ;         //分享方式        1,"小程序三个点，或则卡片分享" ,2,"太阳码分享",3,"二维码分享"
     */
    async setRecord(query, pageUrl) {
        const key = 'recordLoading';
        try {
            query = this.onCompliantScene(query);
            if (this.Model.getStorage(key) ||
                lodash.isEmpty(lodash.get(query, 'shareCode'))) {
                return; //this.ShareSubject.complete()
            }
            this.Model.setStorage(key, true);
            const res = await AjaxBasics.request({
                ...EnumAPI.content_live_record,
                body: { pageUrl },
            });
            this.Model.merge(res);
            this.Model.setStorage(key, false);
            return res;
        }
        catch (error) {
            this.Model.setStorage(key, false);
        }
    }
};
__decorate([
    computed
], ShareController.prototype, "shareCode", null);
__decorate([
    computed
], ShareController.prototype, "shareTime", null);
__decorate([
    computed
], ShareController.prototype, "shareType", null);
__decorate([
    computed
], ShareController.prototype, "scene", null);
__decorate([
    computed
], ShareController.prototype, "businessType", null);
__decorate([
    computed
], ShareController.prototype, "identityId", null);
__decorate([
    computed
], ShareController.prototype, "userId", null);
ShareController = __decorate([
    BindAll()
], ShareController);
export { ShareController };
